<div class="container">
  <form *ngIf="transaction" name="redirectForm" method="POST" [action]="transaction.redirectionUrl">
    <input type="hidden" name="redirectionVersion" [value]="transaction.redirectionVersion" />
    <input type="hidden" name="redirectionData" [value]="transaction.redirectionData" />
  </form>
  
  <h2 *ngIf="transaction">
    Vous allez être redirigé vers notre passerelle de paiement.
  </h2>
</div>